// this is an autogenerated file from DesignSystem/ManualAutomations/Content/Content/ActiveAction/CreateProcedureReceivables/Content/Content/Invoice/Content/Charges/Charge/Type/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_ManualAutomations_Content_Content_ActiveAction_CreateProcedureReceivables_Content_Content_Invoice_Content_Charges_Charge_Type($location_id: uuid!) {
  vaxiom_misc_fee_charge_templates(
    where: { organization: { _id: { _eq: $location_id } } }
    order_by: { name: asc_nulls_last }
  ) {
    id
    text: name
    name
    price
    affecting_production_report
  }
}

`